import { CONSTANT_URL } from './../constant/constant-url';
import { environment } from './../environments/environment';
import { GUEST_RESERVATION_AUTH } from './../environments/environment';
import { UtilService } from './share/util/util.service';
import { ROLES, SMILE9_ROLES } from '../environments/environment';
import { Component, HostListener, OnInit } from '@angular/core';
import { AuthenticateService } from './share/authenticate/authenticate.service';
import { Router, NavigationEnd, NavigationStart, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { MsgService } from './share/msg/msg.service';
import { NavbarService } from './navbar/navbar.service';
declare var $;
declare var nfcCardReader;
import { SCAN_TYPE_MSG } from './share/msg/scan-type-msg';
import { CONSTANT } from '../constant/constant';
import * as AWS from 'aws-sdk';
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: environment.amplify.Auth.userPoolId
});
AWS.config.region = environment.amplify.Auth.region;
import Amplify from 'aws-amplify';
import { Meta } from '@angular/platform-browser';
import { ImportEmpCsvService } from './general-affairs/master/import-emp-csv/import-emp-csv.service';
import { ImportEmpCsvObserveUpdateService } from './general-affairs/master/import-emp-csv/import-emp-csv-observe-update.service';
import { TutorialKeepPropService } from './share/tutorial/tutorial.service';
declare const System;
// flatpickrの日本語化
import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js"
import { UtilAsync } from './share/util/utilAsync';
import { SentryInit } from './share/sentry/sentry-init';
import { SentryObserve } from './share/sentry/sentry-observe';
flatpickr.localize(Japanese);

$(function() {
  // 多重Modalを表示した際に下層Modalがスクロール出来なくなることを防止する
  $(document).on('hidden.bs.modal', () => {
    if ($('.modal').is(':visible')) {
      $('body').addClass('modal-open');
    }
  });

  // Modal展開時にブラウザの「戻る」をすると、Modalの判定が残る為、全てのModalを必ず消去する
  $(window).on('popstate', () => {
    $('.modal').modal('hide');
  });
});

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public SKS_WEBSITE = CONSTANT_URL.SKS_WEBSITE;
  public ROLES = ROLES;
  public SMILE9_ROLES = SMILE9_ROLES;
  public GUEST_RESERVATION_AUTH = GUEST_RESERVATION_AUTH;
  public SCAN_TYPE_MSG = SCAN_TYPE_MSG;
  public UG_OPTION = CONSTANT.UG_OPTION;
  public SMILE9_USER_SETTINGS = CONSTANT.SMILE9_USER_SETTINGS;
  public scrollTopBtnVisible = false;
  public isRegisterFavInUrl = false;
  public isMaintenanceUrl = false;
  public isShowingRouteLoadIndicator: boolean;
  public environmentName = environment.name;
  public SKS_TERMS_OF_SERVICE = CONSTANT_URL.SKS_TERMS_OF_SERVICE;

  constructor (
    public meta: Meta,
    public authServ: AuthenticateService,
    private router: Router,
    private msgServ: MsgService,
    public utilServ: UtilService,
    public navbarServ: NavbarService,
    private importEmpCsvServ: ImportEmpCsvService,
    private importEmpCsvObserve: ImportEmpCsvObserveUpdateService,
    public tutorialServ: TutorialKeepPropService,
  ) {
    // Amplifyの設定をenvironment.tsからロード
    Amplify.configure(environment.amplify);

    // Googleのクローラー回避の為、本番環境以外はmetaタグを動的追加
    if (environment.name !== 'production') {
      meta.addTag({ name: 'robots', content: 'noindex' });
    }

    this.isShowingRouteLoadIndicator = false;
    let asyncLoadCount = 0;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // ページ遷移前に、過去のトースターを消す
        this.msgServ.remove();
      }

      if (event instanceof NavigationEnd) {
        // ルーティングによるページ遷移完了後
        window.scrollTo(0, 0);
        this.isRegisterFavInUrl = /(register-fav|favorite-signin)/.test(location.pathname);
        this.isMaintenanceUrl = /maintenance/.test(location.pathname);
        this.utilServ.uTrans.resetAsyncRequesting();
        // APIGatewayからアプリのステータス取得
        this.navbarServ.getAppStatus();
        // 通知データ取得
        this.navbarServ.getNoticeAsync();
        this.importEmpCsvObserve.checkGeneralAffairsToken(this.authServ.smile9Role);

        this.killWijmoLabel();
      }

      // モジュールの遅延ロードをカウントする
      if ( event instanceof RouteConfigLoadStart ) {
        asyncLoadCount++;
      } else if ( event instanceof RouteConfigLoadEnd ) {
        asyncLoadCount--;
      }
      this.isShowingRouteLoadIndicator = !!asyncLoadCount;
   });
  }

  isCurrentPath(bigTopicName: string): boolean {
    const pathArray: string[] = window.location.pathname.split('/');
    if (pathArray[pathArray.length - 2] === bigTopicName) {
      return true;
    }
    return false;
  }

  getCurrentPathname(): string {
    return location.pathname;
  }

  ngOnInit() {
    const envName = environment.name;
    if (envName !== 'prod') {
      console.log(`current Angular environment is " ${envName} ".`);
    }

    this.lazyLoadFontCss();
    this.lazyLoadJs();
    this.getGlobalIpAsync();
    this.setVisiblityChangeListener();
    this.memorizeStartupTime();
  }

  // Page Visibility APIで画面の再表示を判定。再表示した際は改めて通知データを取得し直す。（常に最新のAngularが取得できるようにする）
  private setVisiblityChangeListener(): void {
    let hidden, visibilityChange;
    // 複数ブラウザへの対応
    if (typeof document.hidden !== 'undefined') {
      hidden = 'hidden';
      visibilityChange = 'visibilitychange';
    } else if (typeof document['mozHidden'] !== 'undefined') {
      hidden = 'mozHidden';
      visibilityChange = 'mozvisibilitychange';
    } else if (typeof document['msHidden'] !== 'undefined') {
      hidden = 'msHidden';
      visibilityChange = 'msvisibilitychange';
    } else if (typeof document['webkitHidden'] !== 'undefined') {
      hidden = 'webkitHidden';
      visibilityChange = 'webkitvisibilitychange';
    }

    if (typeof document.addEventListener === 'undefined' || hidden === undefined) {
      console.log('your browser do not support the Page Visibility API.');
    } else {
      document.addEventListener(visibilityChange, () => {
        // 通知データ取得(カードスキャン系のページでは取得しない)
        if (!document[hidden] && location.pathname.indexOf('/scan-card/') === -1) {
          this.navbarServ.getNoticeAsync();
        }
      }, false);
    }
  }

  private lazyLoadFontCss() {
    const loadDeferredStyles = function() {
      const addStylesNode = document.getElementById('deferred-styles');
      const replacement = document.createElement('div');
      replacement.innerHTML = addStylesNode.textContent;
      document.body.appendChild(replacement);
      addStylesNode.parentElement.removeChild(addStylesNode);
    };
    const raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame;
    if (raf) raf(function() { window.setTimeout(loadDeferredStyles, 0); });
    else window.addEventListener('load', loadDeferredStyles);
  }

  private lazyLoadJs() {
    import('../assets/nfc-card-reader/nfc-card-reader.js').then(module => {
      module.init();
    });
  }

  /** グローバルIPを外部サイトより取得。レスポンスが遅いので非同期実施。
   * IP取得完了前にレコード更新の可能性有。その場合DBのipカラムは'0.0.0.0'で登録される。 */
  private async getGlobalIpAsync() {
    this.utilServ.uTrans.getCurrentUserGlobalIp().subscribe(
      ip => {
        if (!ip) {
          this.authServ.ip = '0.0.0.0';
        } else {
          this.authServ.ip = ip['ip'];
        }
      },
      error => {
        this.authServ.ip = '0.0.0.0';
      }
    );
  }

  /** アプリ初回起動時間をlocalStorageに記憶 */
  private memorizeStartupTime(): void {
    const today = new Date();
    if (!sessionStorage.getItem('startupTime')) {
      sessionStorage.setItem('startupTime', today.toLocaleString('ja'));
    }
    sessionStorage.setItem('latestReloadTime', today.toLocaleString('ja'));
  }

  // スクロールイベント監視
  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    const currentPos = event.srcElement.defaultView.scrollY;
    if (currentPos > 1000) {
      if (this.utilServ.uUI.scrollTopBtnVisible === false) { this.utilServ.uUI.scrollTopBtnVisible = true; }
    } else {
      if (this.utilServ.uUI.scrollTopBtnVisible === true) { this.utilServ.uUI.scrollTopBtnVisible = false; }
    }
  }

  public scrollTop(): void {
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
  }

  public reload(): void {
    // 引数にtrue指定でハードリロード実行
    location.reload(true);
  }

  public removeEnvLabel(): void {
    $('#current-env-label').remove();
  }

  private killWijmoLabel(): void {
    if (this.environmentName === 'prod') { return; }
    const wijmoLabel = $("a:contains('Wijmo トライアル版')");
    if (wijmoLabel.length === 0) { return; }

    setTimeout(() => {
      if (wijmoLabel.length === 0) { return; }
      wijmoLabel.parent('div').remove();
      console.log('kill wijmo label.');
    }, 3000);
  }
}

